import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { pickQtySchema } from './pick-qty-schema.js';
// No qty moves the whole row; a qty below the row's splits that much off onto the lot.
export const changePickItemLotInputSchema = z.object({
    pickItemId: requiredUuidString('Pick item is required.', 'Invalid pick item selection.'),
    tagId: requiredUuidString('Choose a lot.', 'Invalid lot selection.'),
    qty: pickQtySchema('Enter a quantity to move.').nullish(),
});
//# sourceMappingURL=change-pick-item-lot-input.js.map